import request from "superagent";
import _ from "lodash";
import state from "../state";
import playerPaths from "../constants/paths/playerPaths";
import env from "../constants/env";
import * as Utils from "../utils/utils";

export async function generateAmbifiFontCss(fontRefs) {

	let promises = [];
	let fontsMetadata = {};

	let ambifiFontsCache = state.get(playerPaths.AMBIFI_FONTS_CACHE);

	_.each(fontRefs, (fontRef) => {

		if (_.isUndefined(ambifiFontsCache[fontRef])) {

			let url = env.cloudFront.fontsUrl + "/" + fontRef + "/metadata.json";
			let promise = request
				.get(url)
				.set("Content-Type", "application/json")
				.then(res => {
					let fontMetadata = res.body;
					fontsMetadata[fontRef] = fontMetadata;
					state.set([...playerPaths.AMBIFI_FONTS_CACHE, fontRef], fontMetadata);
				});
			promises.push(promise);	
		} else {
			fontsMetadata[fontRef] = ambifiFontsCache[fontRef];
		}
	});

	await Promise.all(promises);

	return generateAmbifiFontCssFromMetadata(fontsMetadata);
}


function generateAmbifiFontCssFromMetadata(fontsMetadata) {

	let fontsUrl = env.cloudFront.fontsUrl;
	let cssObjects = [];

	_.each(fontsMetadata, (fontMetadata, key) => {

		let fontFamily;

		_.each(fontMetadata.files, (filePath) => {

			let fileName = Utils.getFileNameFromPath(filePath);
			let fileNameNoExtension = Utils.stripExtension(fileName);

			if (_.isUndefined(fontFamily)) {
				fontFamily = getFontFamilyFromFileName(fileName);				
			}
						
			let cssObj = {
				"font-family": `'${fontFamily}'`,
				"src": `local('${fontFamily}'), url(${fontsUrl}/${key}/${filePath})`
			};

			if (fileNameNoExtension.endsWith("BoldItalic")) {
				cssObj["font-weight"] = "bold";
				cssObj["font-style"] = "italic";
			} else if (fileNameNoExtension.endsWith("Bold")) {
				cssObj["font-weight"] = "bold";
			} else if (fileNameNoExtension.endsWith("Italic")) {
				cssObj["font-style"] = "italic";
			}

			cssObjects.push(cssObj);
		});
	});

	let css = "";

	_.each(cssObjects, (cssObject) => {
		css += serializeCssObject(cssObject) + "\n";
	});

	return css;
}


function serializeCssObject(cssObject) {

	let css = "@font-face {\n";

	_.each(cssObject, (prop, key) => {
		css += `${key}:${prop};\n`;
	});
	
	css += "}\n";

	return css;
}

function getFontFamilyFromFileName(fileName) {

	let tokens = fileName.split("-");
	let familyCamelCase = tokens[0];
	return familyCamelCase.replace(/([a-z0-9])([A-Z])/g, "$1 $2");
}